export const cilBold = ["24 24","<path d='M0.75 0.75v22.5h22.5v-22.5zM21.75 21.75h-19.5v-19.5h19.5z'></path><path d='M15 18.75c0 0 0 0 0 0 2.071 0 3.75-1.679 3.75-3.75 0-1.711-1.145-3.154-2.711-3.604l-0.026-0.007c0.537-0.644 0.863-1.48 0.863-2.392 0-2.070-1.678-3.748-3.748-3.748-0.001 0-0.001 0-0.002 0h-7.875v1.5h1.875v10.5h-1.875v1.5zM9.75 17.25v-4.5h4.125c1.243 0 2.25 1.007 2.25 2.25s-1.007 2.25-2.25 2.25v0zM12 6.75c1.243 0 2.25 1.007 2.25 2.25s-1.007 2.25-2.25 2.25v0h-2.25v-4.5h2.25z'></path>"]


//////////////////
// WEBPACK FOOTER
// ./node_modules/@coreui/icons/js/free/cil-bold.js
// module id = null
// module chunks = 